import { CONFIG } from 'src/global-config';

import { WorkspaceEnum, AdminRoleEnum, ROLE_DISPLAY_NAMES } from 'src/types/user';

import type { WorkspacesPopoverProps } from './components/workspaces-popover';

// ----------------------------------------------------------------------

export const _workspaces: WorkspacesPopoverProps['data'] = [
  {
    id: WorkspaceEnum.Administrator,
    name: ROLE_DISPLAY_NAMES[AdminRoleEnum.Administrator],
    logo: `${CONFIG.assetsDir}/assets/icons/workspaces/token-branded--kingshib.png`,
  },
  {
    id: WorkspaceEnum.Supervisor,
    name: ROLE_DISPLAY_NAMES[AdminRoleEnum.Supervisor],
    logo: `${CONFIG.assetsDir}/assets/icons/workspaces/fluent-emoji--magnifying-glass-tilted-left.png`,
  },
  {
    id: WorkspaceEnum.EditorBoss,
    name: ROLE_DISPLAY_NAMES[AdminRoleEnum.EditorManager],
    logo: `${CONFIG.assetsDir}/assets/icons/workspaces/personas.png`,
  },
  {
    id: WorkspaceEnum.Editors,
    name: ROLE_DISPLAY_NAMES[AdminRoleEnum.Editor],
    logo: `${CONFIG.assetsDir}/assets/icons/workspaces/icon-park--write.png`,
  },
  {
    id: WorkspaceEnum.Outreach,
    name: ROLE_DISPLAY_NAMES[AdminRoleEnum.Outreach],
    logo: `${CONFIG.assetsDir}/assets/icons/workspaces/mdi--send.png`,
  },
  {
    id: WorkspaceEnum.Accountant,
    name: ROLE_DISPLAY_NAMES[AdminRoleEnum.Accountant],
    logo: `${CONFIG.assetsDir}/assets/icons/workspaces/emojione-v1--money-with-wings.png`,
  },
];
